/**
 * Main app.
 * The app shows a loading indicator while it is waiting for everything to set up.
 * Individual routes may prevent display of the header, footer, etc by setting meta.contentOnly: true.
 */
import Banner from "@/components/Banner/PageBanner.vue";
import Breadcrumbs from "@/components/Breadcrumbs/PageBreadcrumbs.vue";
import Footer from "@/components/Footer/PageFooter.vue";
import Navigation from "@/components/Navigation/PageNavigation.vue";

import LoadingSpinner from "@/components/LoadingSpinner/LoadingSpinner.vue";

export default {
  name: "App",
  components: {
    Banner,
    Breadcrumbs,
    Footer,
    LoadingSpinner,
    Navigation,
  },
  computed: {
    /**
     * Determine whether or not to show the loading indicator.
     * @returns Boolean
     */
    showLoading() {
      return !this.$route.name;
    },

    /**
     * Determine whether or not to show the page chrome (header, footer, etc).
     * @returns Boolean
     */
    showChrome() {
      // If the route hasn't been properly loaded yet, do not show chrome until we are sure we need it.
      if (this.showLoading) {
        return false;
      }
      // If the route has been loaded then use its contentOnly meta parameter to determine whether to show chrome.
      return !this.$route.meta.contentOnly;
    },
  },
  mounted() {
    // Remove the hard-coded loading spinner (it gets replaced with the one in this component).
    // If the loading spinner starts appearing twice, place this code into created() rather than mounted().
    let node = document.getElementById("initialLoadingSpinner");
    if (node && node.parentNode) {
      node.parentNode.removeChild(node);
    }
  },
};
